<template>
	<div id="LoginCallback">
		<span>{{message}}</span>
	</div>
</template>

<script>
	import { Component, Vue } from 'vue-property-decorator';
	import DefaultLayout from '../../layouts/Default/index.vue';
	import ConfirmDialog from '../../components/ConfirmDialog/index.vue';

	@Component({
		components: {
			DefaultLayout,
			ConfirmDialog
		},
	})
	export default class ViewLoginCallback extends Vue {
		
		message = ''
		
		mounted() {
			const code = ViewLoginCallback._getQueryParam('code');
			// TODO send code to parent
			if (window && window.opener) {
				// TODO: not star
				window.opener.postMessage({code}, '*');
				this.message = 'WELCOME';
			}
			else {
				// TODO: handle error better
				this.message = 'ERROR: COULD NOT SEND CODE';
			}
		}

		/**
		 * Checks the url if query parameter 'id' is present.
		 * @param id
		 * @returns {string | null}
		 * @private
		 */
		static _getQueryParam(id) {
			const url = window.location.href;
			id = id.replace(/[[\]]/g, "\\$&");
			const regex = new RegExp("[?&]" + id + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) return null;
			if (!results[2]) return '';
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		}
	}
</script>

<style lang="scss">
#LoginCallback {
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
}
</style>